import React from 'react';
import { useLocation, Navigate } from 'react-router-dom';

// Import all admin pages
import Dashboard from '../pages/Dashboard';
import Student from '../pages/Student';
import BulkUpload from '../pages/Student/BulkUpload';
import UserRisk from '../pages/Student/UserRisk';
import AddMember from '../pages/Member/AddMember';
import MemberDetail from '../pages/Member/Detail';
import Practitioner from '../pages/Practitioner';
import AddPractitioner from '../pages/Practitioner/AddPractitioner';
import PractitionerDetail from '../pages/Practitioner/Detail';
import Appointments from '../pages/Appointments';
import AppointmentDetail from '../pages/Appointments/Detail';
import Calender from '../pages/Calender';
import Settings from '../pages/Settings';
import Support from '../pages/Support';
import Profile from '../pages/Profile';
import Wellness from '../pages/Wellness';
import HealthCamp from '../pages/HealthCamp';
import RunSurvey from '../pages/Survey';
import Counsellor from '../pages/Counsellor';
import AddCounsellor from '../pages/Counsellor/AddCounsellor';
import MemberSummaryReport from '../pages/MemberSummaryReport';
import KycUsers from '../pages/KycUsers';
import { isKycUsersOrgAdmin } from '../../../utils/orgAccess';

export default function AdminRoutes() {
  const location = useLocation();
  const path = location.pathname;

  // Check if user is authenticated (basic check for now)
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('userRole');

  // Redirect to login if not authenticated
  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Redirect to member dashboard if user is CLIENT (they switched from Admin to Member)
  // CLIENT users should only access /member/* routes
  if (userRole === 'CLIENT') {
    return <Navigate to="/member/dashboard" replace />;
  }

  // Determine which page component to render based on current path
  let PageComponent;

  if (path === '/dashboard') PageComponent = Dashboard;
  else if (path === '/members') PageComponent = Student;
  else if (path === '/add-member') PageComponent = AddMember;
  else if (path.startsWith('/member-detail/')) PageComponent = MemberDetail;
  else if (path === '/bulk-student') PageComponent = BulkUpload;
  else if (path === '/user-risk') PageComponent = UserRisk;
  else if (path === '/practitioner') PageComponent = Practitioner;
  else if (path === '/add-practitioner') PageComponent = AddPractitioner;
  else if (path.startsWith('/practitioner-detail/')) PageComponent = PractitionerDetail;
  else if (path === '/appointments') PageComponent = Appointments;
  else if (path.startsWith('/appointment-detail/')) PageComponent = AppointmentDetail;
  else if (path === '/calender') PageComponent = Calender;
  else if (path === '/settings') PageComponent = Settings;
  else if (path === '/support') PageComponent = Support;
  else if (path === '/profile') PageComponent = Profile;
  else if (path === '/schedule-wellness') PageComponent = Wellness;
  else if (path === '/schedule-health-camp') PageComponent = HealthCamp;
  else if (path === '/run-survey') PageComponent = RunSurvey;
  else if (path === '/counsellor-managment') PageComponent = Counsellor;
  else if (path === '/add-counsellor') PageComponent = AddCounsellor;
  else if (path.startsWith('/member-summary-report/')) PageComponent = MemberSummaryReport;
  else if (path === '/kyc-users' && isKycUsersOrgAdmin()) PageComponent = KycUsers;
  else return <Navigate to="/dashboard" replace />;

  // Each page renders its own TopBar, so no shared header here
  // (rendering one here too mounted it twice and fetched org data twice)
  return <PageComponent />;
}
